export default __webpack_public_path__ + "static/media/topic3.cd3d514c.png";